import { axiosInstance } from './base'

export function fetchMyListings () {
  return axiosInstance.get('mylisting/')
}
